import React from "react";

// import EstimationColumns from './estimationColumns';
import {MaterialReactTable} from "material-react-table";
import { Button, ListItemIcon, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EstimationColumns from "./estimationColumns";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import FactCheckIcon from "@mui/icons-material/FactCheck";

const tableProps = {
  muiTableHeadCellProps: {
    sx: {
      backgroundColor: "hsla(250, 86%, 97%, 1)",
      borderRight: "1px solid rgba(224,224,224,1)",
      borderTop: "1px solid rgba(224,224,224,1)",
      "& .Mui-TableHeadCell-Content-Wrapper": {
        whiteSpace: "normal",
        justifyContent: "center",
        marginBottom: "0.4px",
      },
      fontSize: "0.7rem",
      verticalAlign: "middle",
      height: "40.4px",
    },
  },
  muiTableProps: {
    size: "small",
    sx: {
      "& .MuiInputBase-root": {
        fontSize: "0.7rem",
        borderRadius: 0,
      },
      "& .MuiButtonBase-root": {
        fontSize: "0.7rem",
      },
    },
  },
  muiTableBodyCellProps: {
    sx: {
      borderRight: "1px solid rgba(224,224,224,1)",
      padding: "0rem",
      paddingLeft: "5px",
      // height: "30.4px"
    },
  },
};

const EstimationTable = (props) => {
  const {
    rows,
    handleSaveCell,
    handleCreateNewRow,
    handleDeleteRow,
    isLoading,
    getValues,
    handleCompareCost,
    handleCheckStock,
  } = props;
  return (
    <MaterialReactTable
      columns={EstimationColumns(getValues, handleSaveCell)}
      data={rows ?? []}
      getRowId={(originalRow, index) =>
        originalRow.__rowId ?? `${index}-${originalRow.Description ?? ""}`
      }
      enableEditing={false}
      enableColumnActions={false}
      enableRowActions
      positionActionsColumn="last"
      {...tableProps}
      muiTableHeadCellProps={({ cell }) => ({
        sx: {
          borderRight: "1px solid rgba(224,224,224,1)",
          backgroundColor: "hsla(250, 86%, 97%, 1)",
          fontSize: "14px",
          pt: 2,
        },
      })}
      muiTableBodyCellProps={{
        sx: {
          padding: "8.5px 8px",
          textAlign: "center",
          borderRight: "1px solid rgba(224,224,224,1)"
        }
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          size: 5,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
            sx: {
              p: 0,
              "& button": {
                ml: 0,
              },
            },
          },
        },
      }}
      renderBottomToolbarCustomActions={() => (
        <Button
          color="secondary"
          size="small"
          onClick={() => handleCreateNewRow()}
          variant="contained"
        >
          Add row
        </Button>
      )}
      renderRowActionMenuItems={({ row }) => [
        <MenuItem
          key={0}
          sx={{ m: 0 }}
          onClick={() => handleDeleteRow(row.index)}
        >
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          Delete
        </MenuItem>,
        <MenuItem
          key={1}
          sx={{ m: 0 }}
          onClick={() => handleCompareCost(row.original)}
        >
          <ListItemIcon>
            <CompareArrowsIcon />
          </ListItemIcon>
          Compare Cost
        </MenuItem>,
        <MenuItem
          key={2}
          sx={{ m: 0 }}
          onClick={() => handleCheckStock(row.original)}
        >
          <ListItemIcon>
            <FactCheckIcon />
          </ListItemIcon>
          Check availability
        </MenuItem>,
      ]}
      defaultColumn={{
        minSize: 60,
        size: 80,
      }}
      initialState={{
        pagination: { pageSize: 30 },
      }}
      state={{
        isLoading,
      }}
    />
  );
};

export default EstimationTable;
